import React from "react";

interface MatchPageLinkWrapperProps {
  condition: boolean;
  wrapper: (children: React.JSX.Element) => React.JSX.Element;
  children: React.JSX.Element;
}

/**
 * Component used to render link redirecting to match page, if the match page url is available
 */
export const MatchPageLinkWrapper = ({
  condition,
  wrapper,
  children,
}: MatchPageLinkWrapperProps): React.JSX.Element => {
  if (condition) {
    return wrapper(children);
  } else {
    return children;
  }
};
